import { useState } from 'react'
import useFeatureFlag from 'shared/hooks/useFeatureFlag/useFeatureFlag'
import { useShipments } from './api/hooks'
import useOnCurrentUserLoaded from 'shared/hooks/useOnCurrentUserLoaded/useOnCurrentUserLoaded'
import { settingsPath } from 'lib/urls'

const ShipmentView = () => {
  const { flagValue: shipmentViewFeatureFlag } = useFeatureFlag(
    '24c_ff_giftmanagement_shipment_view_web',
    false
  )
  const [showRawData, setShowRawData] = useState(false)

  useOnCurrentUserLoaded((currentUser) => {
    const isShipmentViewEnabled =
      !!shipmentViewFeatureFlag || !!currentUser?.adminId

    if (!isShipmentViewEnabled) {
      window.location.href = settingsPath
    }
  })

  const { data } = useShipments()

  return (
    <div>
      <h1>Shipments</h1>
      <button onClick={() => setShowRawData(!showRawData)}>
        {showRawData ? 'Hide' : 'Show'} JSON
      </button>
      {showRawData && <pre>{JSON.stringify(data, null, 2)}</pre>}
    </div>
  )
}

export default ShipmentView
